"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormFieldTextArea = exports.FormFieldText = exports.FormFieldTextDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var utils_1 = require("@shapeable/utils");
var cls = (0, utils_1.classNames)('form-field-text');
exports.FormFieldTextDefaultProps = {
  multiLine: false,
  value: ''
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    border: 1px solid ", ";\n    font-weight: 400;\n    font-family: ", ";\n    font-size: ", ";\n    padding: ", " ", " ", ";\n    color: ", ";\n    transition: border-color 0.25s;\n    border-radius: ", ";\n    box-shadow: 0px 2px 1px inset rgba(0,0,0, 0.02);\n\n    -webkit-appearance: none;\n\n    &:disabled {\n      background-color: #F7F7F7;\n    }\n\n    &[type=number]::-webkit-inner-spin-button, \n    &[type=number]::-webkit-outer-spin-button { \n    -webkit-appearance: none; \n      margin: 0; \n    }\n\n    &:focus {\n      outline: none;\n      border-color: ", "; \n    }\n\n    &::placeholder {\n      color: ", ";\n    }\n\n    ", "\n\n    ", "\n  "], ["\n    display: flex;\n    border: 1px solid ", ";\n    font-weight: 400;\n    font-family: ", ";\n    font-size: ", ";\n    padding: ", " ", " ", ";\n    color: ", ";\n    transition: border-color 0.25s;\n    border-radius: ", ";\n    box-shadow: 0px 2px 1px inset rgba(0,0,0, 0.02);\n\n    -webkit-appearance: none;\n\n    &:disabled {\n      background-color: #F7F7F7;\n    }\n\n    &[type=number]::-webkit-inner-spin-button, \n    &[type=number]::-webkit-outer-spin-button { \n    -webkit-appearance: none; \n      margin: 0; \n    }\n\n    &:focus {\n      outline: none;\n      border-color: ", "; \n    }\n\n    &::placeholder {\n      color: ", ";\n    }\n\n    ", "\n\n    ", "\n  "])), theme_1.theme.COLOR('line-mid'), theme_1.theme.FONT('sans'), theme_1.theme.FONT_SIZE(16), theme_1.theme.UNIT(3.5), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3.6), theme_1.theme.COLOR('bold'), theme_1.theme.UNIT(2), theme_1.theme.COLOR('primary'), theme_1.theme.COLOR('text-very-subtle'), function (props) {
    return props._maxWidth && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      max-width: ", ";\n    "], ["\n      max-width: ", ";\n    "])), props._maxWidth);
  }, function (props) {
    return props.variant === 'gradient' && !props.valid && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      border-color: ", ";\n      border-top-color: ", ";\n    "], ["\n      border-color: ", ";\n      border-top-color: ", ";\n    "])), theme_1.theme.COLOR('line-mid'), theme_1.theme.COLOR('error'));
  })
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.input(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
var FormFieldText = function (props) {
  var className = props.className,
    autoFocus = props.autoFocus,
    value = props.value,
    placeholder = props.placeholder,
    disabled = props.disabled;
  var handleBlur = props.onBlur && function (event) {
    event.preventDefault();
    event.stopPropagation();
    props.onBlur({
      event: event,
      value: event.target.value
    });
  };
  var handleChange = props.onChange && function (event) {
    event.preventDefault();
    event.stopPropagation();
    props.onChange({
      event: event,
      value: event.target.value
    });
  };
  return react_1.default.createElement(My.Container, {
    autoFocus: autoFocus,
    className: cls.name(className),
    name: "name",
    placeholder: placeholder,
    type: "text",
    disabled: disabled,
    value: value,
    onBlur: handleBlur,
    onChange: handleChange
  });
};
exports.FormFieldText = FormFieldText;
var FormFieldTextArea = function (props) {
  return react_1.default.createElement(exports.FormFieldText, __assign({}, props, {
    multiLine: true
  }));
};
exports.FormFieldTextArea = FormFieldTextArea;
exports.FormFieldTextArea.cls = cls;
exports.FormFieldTextArea.defaultProps = exports.FormFieldTextDefaultProps;
exports.FormFieldText.cls = cls;
exports.FormFieldText.defaultProps = exports.FormFieldTextDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;